import { CustomerInvoices } from "./CustomerInvoices";
import { InvoiceStatsData } from "../../../@types";
import { CustomerT } from "../../../types";
import { CustomerContact } from "./CustomerContact";

interface CustomerInfoProps {
  customer: CustomerT;
  currency: string;
}

export const CustomerInfo: React.FC<CustomerInfoProps> = ({
  customer,
  currency,
}) => (
  <div className="md:flex md:flex-col md:items-start md:gap-6 md:mt-8">
    <CustomerInvoices customer={customer} currency={currency} />
    <CustomerContact customer={customer} />
  </div>
);
